import script from "./LeaderProjectFormStep10.vue?vue&type=script&setup=true&lang=js"
export * from "./LeaderProjectFormStep10.vue?vue&type=script&setup=true&lang=js"

import "./LeaderProjectFormStep10.vue?vue&type=style&index=0&id=0bd3904b&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bd3904b"]])

export default __exports__